import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectPreferredLanguage } from "features/authSlice";
import { dashboardApi } from "pages/dashboard/home/dashboardService";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import type { AppDispatch } from "store";
import { persistor } from "store";
import { enterMyLoansAfterAuth } from "utilities/langPrefCookie";

export const useGoToMyLoansAfterAuth = (): ((userId: string) => Promise<void>) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const reduxLanguage = useSelector(selectPreferredLanguage);
  const { data: featureFlag } = useGetFeatureFlagsQuery();

  return useCallback(
    async (userId: string) => {
      await enterMyLoansAfterAuth({
        userId,
        reduxLanguage,
        isPreferredLanguageEnabled: Boolean(featureFlag?.preferredLanguageEnabled),
        fetchUserDbLanguage: async (id) => {
          const profile = await dispatch(dashboardApi.endpoints.getBorrowerDetails.initiate(id)).unwrap();
          return profile.preferredLanguage;
        },
        persistFlush: () => persistor.flush(),
        spaNavigate: () => {
          navigate("/my-loans", { replace: true });
        },
      });
    },
    [dispatch, featureFlag?.preferredLanguageEnabled, navigate, reduxLanguage],
  );
};
